import type { TicketSaleTarget } from 'Services/SalesManagement/Features/TicketSale/types'
import { Autocomplete, type SxProps, TextField, type Theme } from '@mui/material'
import { useMemo } from 'react'
import { t } from 'ttag'

interface TicketSaleTargetSelectProps {
  targets: TicketSaleTarget[]
  value: string
  onChange: (value: string) => void
  error?: string
  sx?: SxProps<Theme>
}

export default function TicketSaleTargetSelect({
  targets,
  value,
  onChange,
  error,
  sx
}: Readonly<TicketSaleTargetSelectProps>) {
  const options = useMemo(
    () => targets.map(target => ({ label: target.identifier, id: target.id })),
    [targets]
  )

  const selectedOption = useMemo(
    () => options.find(option => option.id === value) ?? null,
    [options, value]
  )

  return (
    <Autocomplete
      sx={{ display: 'inline-flex', ...sx }}
      value={selectedOption}
      options={options}
      isOptionEqualToValue={(opt, val) => !!val && opt.id === val.id}
      onChange={(_event, newValue) => onChange(newValue?.id ?? '')}
      renderInput={params => (
        <TextField
          {...params}
          required
          name="target"
          label={t`Target`}
          error={!!error}
          helperText={error ?? ''}
        />
      )}
    />
  )
}
